<div class="sidebar">
    <a class="logo" routerLink="/home">
        <app-logo></app-logo>
    </a>

    <div class="top-right-block"></div>

    <nav class="nav-items">
        <div *ngFor="let item of navItems" class="nav-item" [class.active]="isActive(item.route)"
            (click)="navigate(item.route)">
            <div class="icon-container">
                <ng-container [ngSwitch]="item.iconComponent">
                    <app-star *ngSwitchCase="'StarComponent'"></app-star>
                    <app-pencil *ngSwitchCase="'PencilComponent'"></app-pencil>
                    <app-diamond *ngSwitchCase="'DiamondComponent'"></app-diamond>
                    <app-list *ngSwitchCase="'ListComponent'"></app-list>
                    <app-screens *ngSwitchCase="'ScreensComponent'"></app-screens>
                    <app-chat-icon *ngSwitchCase="'ChatIconComponent'"></app-chat-icon>
                    <app-settings-icon *ngSwitchCase="'SettingsIconComponent'"></app-settings-icon>
                </ng-container>
            </div>
            <span>{{item.label | translate}}</span>
        </div>
    </nav>

    <div class="logout-item" (click)="logout()" *ngIf="isLoggedIn">
        <div class="icon-container">
            <app-logout-icon></app-logout-icon>
        </div>
        <span>{{ 'Menu.logout' | translate}}</span>
    </div>

    <div class="logout-item" (click)="navigateToLogin()" *ngIf="!isLoggedIn">
        <div class="icon-container">
            <app-logout-icon></app-logout-icon>
        </div>
        <span>{{ 'Menu.items.loginOrLogout' | translate}}</span>
    </div>

    <div class="bottom-left-block"></div>
</div>